import React, { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {useDispatch} from "react-redux";

import {Translation as T} from "@awe-web/shared/lib";
import { useInitialize } from "../../util/react.js";
import {ScreenSection, ScreenHeading, ScreenLoading} from "../../components/screen.js";
import {Row, Col} from "../../components/grid.js";
import {TypeArea} from "../../components/layout.js";
import {initialize} from "./actions.js";
import ResetPasswordEntryForm from "./reset_password_entry_form";

const SET_NEW_PASSWORD = "FSD0000351";

export default function ResetPasswordEntry() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetPasswordToken = searchParams.get('token');
  const classification = searchParams.get('classification');

  const init = useCallback(async () => {
    const nextPath = await dispatch(initialize(resetPasswordToken, classification));
    if (nextPath && nextPath.length > 0) {
      navigate(nextPath);
    }
  }, [classification, dispatch, navigate, resetPasswordToken]);

  const isReady = useInitialize(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div className="my-bmw-rent-profile">
      <ScreenSection main dark>
        <TypeArea>
          <Row>
            <Col desktop={{cols: 4, offset: 4}}>
              <ScreenHeading><T code={SET_NEW_PASSWORD} /></ScreenHeading>
            </Col>
          </Row>

          <Row>
            <Col desktop={{cols: 4, offset: 4}}>
              <ResetPasswordEntryForm />
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
